import { VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

type FieldCopyProps = {
  title: string;
  description?: string;
};

export function FieldCopy({ title, description }: FieldCopyProps) {
  return (
    <VStack spacingBottom={3} gap={0.5}>
      <TextTitle3 as="p">{title}</TextTitle3>
      {description && (
        <TextBody as="p" color="foregroundMuted">
          {description}
        </TextBody>
      )}
    </VStack>
  );
}
